import * as pc from "playcanvas";
import { Atlas } from "./render/atlas.ts";
import { Game } from "./game/game.ts";
import { fetchAccount, type Account } from "./game/cloud.ts";
import { showSignIn } from "./game/signin.ts";

const stage = document.getElementById("stage") as HTMLElement;
const canvas = document.getElementById("game") as HTMLCanvasElement;
const hudRoot = document.getElementById("hud") as HTMLElement;
const fade = document.getElementById("fade") as HTMLElement;

// Who is playing decides whether there is a game to boot at all. This is one
// request against our own origin before the first frame; the atlas build that
// follows is far and away the longer wait.
const account = await fetchAccount();

if (account.authRequired && !account.signedIn) {
  showSignIn(stage, account);
} else {
  start(account);
}

function start(account: Account): void {
  const app = new pc.Application(canvas, {
    graphicsDeviceOptions: {
      antialias: false,
      alpha: false,
      depth: true,
      preserveDrawingBuffer: false,
      powerPreference: "high-performance",
    },
  });

  // pixel art: one texel per screen pixel, never a fractional device ratio
  app.graphicsDevice.maxPixelRatio = 1;
  app.setCanvasFillMode(pc.FILLMODE_FILL_WINDOW);
  app.setCanvasResolution(pc.RESOLUTION_AUTO);
  app.scene.ambientLight = new pc.Color(1, 1, 1);

  canvas.addEventListener("contextmenu", (e) => e.preventDefault());

  const atlas = new Atlas(app.graphicsDevice);
  const game = new Game(app, atlas, hudRoot, fade, account);

  app.on("update", (dt: number) => {
    // long stalls (tab in the background) must not teleport the farmer
    game.update(Math.min(dt, 0.05));
  });

  app.start();

  // handy while developing
  Object.assign(globalThis, { app, game, atlas });
}
